

<angular2-multiselect 
  [data]="memberList" 
  [(ngModel)]="selectedItems"
  [settings]="dropdownSettings"
  (onSelect)="onItemSelect($event)"
  (onDeSelect)="onItemDeSelect($event)"
  (onGroupSelect)="onSelectAll($event)"
  (onGroupDeSelect)="onDeSelectAll($event)"
  class="custom-ui-li-multi-select-cls"
  >
  <c-badge>
    <ng-template let-item="item" class="d-flex">
      <div class="d-flex">
        <img
          [src]="item.profile_image"
          *ngIf="
            item.profile_image?.charAt(0) !== '#' &&
            item.profile_image?.charAt(0) == 'h'
          "
          class="img-avatar me-2"
          alt="assignee profile"
        />
        <span
          *ngIf="
            item.profile_image?.charAt(0) == '#' ||
            !item.profile_image ||
            item.profile_image?.charAt(0) != 'h'
          "
          class="user-short-name mr-0 me-2"
          [ngStyle]="{ 'background-color': item.profile_image }"
        >
          {{ utils.forShortName(item?.itemName) }}
        </span>
      <label style="margin: 3px;">{{item.itemName}}</label>
      </div>
    </ng-template>
</c-badge>
<c-item>
  <ng-template let-item="item" class="d-flex">
    <div class="d-flex">
      <img
        [src]="item.profile_image"
        *ngIf="
          item.profile_image?.charAt(0) !== '#' &&
          item.profile_image?.charAt(0) == 'h'
        "
        class="img-avatar me-2"
        alt="assignee profile"
      />
      <span
        *ngIf="
          item.profile_image?.charAt(0) == '#' ||
          !item.profile_image ||
          item.profile_image?.charAt(0) != 'h'
        "
        class="user-short-name mr-0 me-2"
        [ngStyle]="{ 'background-color': item.profile_image }"
      >
        {{ utils.forShortName(item?.itemName) }}
      </span>
    <label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
    </div>
  </ng-template>
</c-item>
</angular2-multiselect>

<br>

<ng-container *ngIf="selectedTemplateType !== 'task_to_subtask'">
  <angular2-multiselect 
    [data]="followerList" 
    [(ngModel)]="selectedFollowerItems"
    [settings]="followerDropdownSettings"
    (onSelect)="onFollowerItemSelect($event)"
    (onDeSelect)="onFollowerItemSelect($event)"
    (onGroupSelect)="onFollowerItemSelect($event)"
    (onGroupDeSelect)="onFollowerItemSelect($event)"
    class="custom-ui-li-multi-select-cls"
    >
    <c-badge>
      <ng-template let-item="item" class="d-flex">
        <div class="d-flex">
          <img
            [src]="item.profile_image"
            *ngIf="
              item.profile_image?.charAt(0) !== '#' &&
              item.profile_image?.charAt(0) == 'h'
            "
            class="img-avatar me-2"
            alt="assignee profile"
          />
          <span
            *ngIf="
              item.profile_image?.charAt(0) == '#' ||
              !item.profile_image ||
              item.profile_image?.charAt(0) != 'h'
            "
            class="user-short-name mr-0 me-2"
            [ngStyle]="{ 'background-color': item.profile_image }"
          >
            {{ utils.forShortName(item?.itemName) }}
          </span>
        <label style="margin: 3px;">{{item.itemName}}</label>
        </div>
      </ng-template>
  </c-badge>
  <c-item>
    <ng-template let-item="item" class="d-flex">
      <div class="d-flex">
        <img
          [src]="item.profile_image"
          *ngIf="
            item.profile_image?.charAt(0) !== '#' &&
            item.profile_image?.charAt(0) == 'h'
          "
          class="img-avatar me-2"
          alt="assignee profile"
        />
        <span
          *ngIf="
            item.profile_image?.charAt(0) == '#' ||
            !item.profile_image ||
            item.profile_image?.charAt(0) != 'h'
          "
          class="user-short-name mr-0 me-2"
          [ngStyle]="{ 'background-color': item.profile_image }"
        >
          {{ utils.forShortName(item?.itemName) }}
        </span>
      <label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
      </div>
    </ng-template>
  </c-item>
  </angular2-multiselect>
</ng-container>